export const toFilterSegmentInput = (filterSegment) => {
  if (!filterSegment) return null;

  const { isEnabled, friendlyTitle, sortIndex, filterOptions = [], filterOptionsOperator, filterOptionsInverted, segment } = filterSegment;

  return {
    isEnabled,
    friendlyTitle,
    sortIndex,
    filterOptionsOperator,
    filterOptionsInverted,
    filterOptions: filterOptions.map(({ relationId, options, type }) => ({
      relationId,
      options: [...options], // To make it mutable
      type,
    })),
    segmentId: segment?.id,
  };
};

const toBenchmarkSegmentInput = (benchmarkSegment) => {
  if (!benchmarkSegment) return null;

  const { isEnabled, sortIndex, surveyCategory } = benchmarkSegment;

  return {
    isEnabled,
    sortIndex,
    surveyCategory,
  };
};

export const toAddToReportInput = ({
  reportId, chartComment, addToReportData, surveyGroupId, dataSourceId, filterSegments = [], benchmarkSegments = [],
}) => {
  const {
    title,
    chartSettings,
    contentSettings,
  } = addToReportData;

  return {
    reportId,
    title,
    filter: surveyGroupId ? {
      surveyGroupId,
      dataSourceId,
      filterSegments: filterSegments.map(toFilterSegmentInput),
      benchmarkSegments: benchmarkSegments.map(toBenchmarkSegmentInput),
    } : undefined,
    chartSettings,
    contentSettings: {
      ...contentSettings,
      chartComment,
    },
  };
};
